const esLocale = {
	'heading.footerText': 'Al continuar, acepta nuestros',
	'heading.termsOfService': 'Términos de servicio',
	'commonStrings.contactinfo': 'Información de contacto',
	'commonStrings.forgotPassword': '¿Olvidó la contraseña?',
	'commonStrings.signIn': 'Inicio de sesión',
	'commonStrings.username': 'Nombre de usuario',
	'commonStrings.currentUser': 'Usuario actual',
	'commonStrings.password': 'Contraseña',
	'commonStrings.currentPassword': 'Contraseña nueva',
	'commonStrings.confirmPassword': 'Confirmar contraseña',
	'commonStrings.loginTitle': 'Le damos la bienvenida',
	'commonStrings.mobileLoginTitle': 'Bienvenido al panel de control',
	'commonStrings.mobileWelcomeMessage':
		'Gestiona la experiencia completa del restaurante en una sola plataforma',
	'commonStrings.loginManageTitle':
		'Inicio de sesión como Administrador de Lavu',
	'commonStrings.recoverPassword': 'Recuperar su contraseña.',
	'commonStrings.refreshPage': 'Actualizar',
	'loginErrors.networkErrorMsg': 'Verifique su conexión a internet. ',
	'loginErrors.empty.username': 'Introduzca su nombre de usuario',
	'loginErrors.empty.password': 'Introduzca su contraseña',
	'loginErrors.empty.passwordRedo': 'Introduzca la confirmación',
	'hubqlErrors.SessionTimeOut': 'La sesión expiró debido a la inactividad o su red cambió. Haga clic en el botón Actualizar a continuación',
	'hubqlErrors.InternalError':
		'¡Ha ocurrido un error interno! Por favor intente nuevamente más tarde.',
	'hubqlErrors.UsernameOrPasswordIncorrect':
		'Usuario y/o contraseña incorrectos',
	'hubqlErrors.AccessLevelRequired': 'Lo sentimos, no tiene suficiente acceso',
	'hubqlErrors.Inactive': 'Lo sentimos, esta cuenta ha sido desactivada',
	'hubqlErrors.UnknownError':
		'¡Ha ocurrido un error! Por favor intente nuevamente más tarde.',
	'hubqlErrors.UserNotFound':
		'Lo sentimos, no pudimos encontrar el usuario que estas buscando',
	'hubqlErrors.MaximumResetTokens':
		'Ha excedido el total de intentos permitidos de reestablecer su contraseña por las siguientes 24 horas',
	'hubqlErrors.InvalidEmail': 'Este usuario no tiene un email válido',
	'hubqlErrors.TokenAlreadyUsed':
		'El token ya ha sido usado. Por favor complete nuevamente el formulario de restablecimiento de contraseña para recibir uno nuevo',
	'passwordResetForm.returnLogin': 'Regresar al Inicio de sesión',
	'passwordResetCommon.resetPasswordTitle': 'Restablecimiento de la contraseña',
	'passwordResetCommon.successSubTitle':
		'Por si acaso, verifique su bandeja de correo electrónico no deseado.',
	'passwordResetCommon.defaultSubTitle':
		'Le enviaremos las instrucciones para restablecer su contraseña.',
	'passwordResetCommon.submitBtnMsg': 'Restablecer la contraseña',
	'passwordResetCommon.linkToLoginMsg': 'Regresar al inicio de sesión',
	'passwordResetEmail.successSentEmail':
		'¡Listo! Le enviamos un correo electrónico con instrucciones para restablecer su contraseña.',
	'passwordResetEmail.errorUsername':
		'Lo sentimos, ese nombre de usuario no es válido. Si considera que se trata de un error, comuníquese con ',
	'passwordResetEmail.customerCare': 'Atención al Cliente',
	'landingResetForm.successResetPassword':
		'Se ha establecido su contraseña nueva.',
	'landingResetForm.newPasswordSuccessSubTitle':
		'Su contraseña se ha cambiado correctamente.',
	'landingResetForm.passwordDoesntMatch': 'Las contraseñas no coinciden.',
	'landingResetForm.errorResetPassword':
		'Lo sentimos, no pudimos actualizar su usuario. Si el problema persiste, comuníquese con ',
	'landingResetForm.newPasswordError': 'Debe tener al menos 8 caracteres',
	'landingResetForm.confirmPasswordError': 'La contraseña no coincide',
};

export default esLocale;
